import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Modal from "@insite/mobius/Modal";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { AddressBookContext } from "@store/Overrides/Widgets/Addresses/AddressBook";
import setAddressBookIsOpen from "@store/Store/Components/AddressBookModal/Handlers/SetAddressBookModalIsOpen";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const AddressBookPagination = getWidgetComponent("Addresses/AddressBookPagination");
const AddressBookSearchBox = getWidgetComponent("Addresses/AddressBookSearchBox");
const CreateAddressButton = getWidgetComponent("Addresses/CreateAddressButton");
const AddressBook = getWidgetComponent("Addresses/AddressBook");

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: StoreApplicationState) => {
    return {
        isModalOpen: state.store.components.addressBookModal.isModalOpen,
    };
};

const mapDispatchToProps = {
    setAddressBookIsOpen,
};

export interface AddressBookModalStyles {
    searchBoxGridItem: GridItemProps;
    createAddressGridItem: GridItemProps;
    addressBookWrapper: InjectableCss;
}

export const addressBookModalStyles: AddressBookModalStyles = {
    searchBoxGridItem: {
        width: [10, 10, 10, 8, 8],
    },
    createAddressGridItem: {
        width: [2, 2, 2, 4, 4],
    },
    addressBookWrapper: {
        css: css`
            margin-top: 1.5em;
        `,
    }
};

const styles = addressBookModalStyles;

const AddressBookModal: React.FC<Props> = ({
    isModalOpen,
    setAddressBookIsOpen,
 }) => {
    const [isProcessing, setIsProcessing] = useState(false);

    const modalCloseHandler = () => {
        setAddressBookIsOpen(false);
    };

    return (
        <Modal
            headline={translate("Delivery and Shipping Address Selection")}
            isOpen={isModalOpen}
            handleClose={modalCloseHandler}
            isCloseable={true}
        >
            <AddressBookContext.Provider value={{ isProcessing, setIsProcessing }}>
                <GridContainer>
                    <GridItem {...styles.searchBoxGridItem}>
                        <AddressBookSearchBox />
                    </GridItem>
                    <GridItem {...styles.createAddressGridItem}>
                        <CreateAddressButton />
                    </GridItem>
                </GridContainer>
                <StyledWrapper {...styles.addressBookWrapper}>
                    <AddressBook />
                </StyledWrapper>
                <AddressBookPagination />
            </AddressBookContext.Provider>
        </Modal>
    )
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressBookModal);